const supported = "withCredentials" in new XMLHttpRequest();

function isCorsSupported() {
  return supported;
}

export default isCorsSupported;
